import * as yup from 'yup'
import { validations } from '@edenia/smartgate-errors-module'

import { typesUtils } from 'utils'

const { isGateOut } = typesUtils

const initialValues = {
  name: '',
  type: '',
  is_release_required: false,
  location_id: '',
  client_id: '',
  steps: []
}

const schema = yup.object().shape({
  name: yup.string().required(validations.requiredField.code),
  type: yup.string().required(validations.requiredField.code),
  is_release_required: yup
    .boolean()
    .nullable()
    .when(['type'], {
      is: val => isGateOut(val),
      then: yup.boolean().required(validations.requiredField.code)
    }),
  location_id: yup.string().required(validations.requiredField.code),
  client_id: yup.string().nullable(),
  steps: yup
    .array()
    .of(
      yup
        .object()
        .shape({
          name: yup
            .string()
            .required(validations.requiredField.code)
            .matches(/^[aA-zZ\s]+$/, validations.onlyAlphabets.code),
          fields: yup
            .array()
            .of(
              yup
                .object()
                .shape({
                  name: yup.string().required(validations.requiredField.code),
                  type: yup.string().nullable(),
                  isDefault: yup
                    .boolean()
                    .required(validations.requiredField.code),
                  isRequired: yup
                    .boolean()
                    .required(validations.requiredField.code),
                  showInReport: yup
                    .boolean()
                    .required(validations.requiredField.code),
                  options: yup
                    .array()
                    .of(yup.string().required(validations.requiredField.code))
                    .nullable()
                })
                .required(validations.requiredField.code)
            )
            .required(validations.requiredField.code)
            .required(validations.requiredField.code)
        })
        .required(validations.requiredField.code)
    )
    .required(validations.requiredField.code)
})

export default {
  initialValues,
  schema
}
